__turbopack_context__.v({
  "card": "ExpandedItineraryScroller-module__3V3u4G__card",
  "cardAccommodation": "ExpandedItineraryScroller-module__3V3u4G__cardAccommodation",
  "cardAccommodationActive": "ExpandedItineraryScroller-module__3V3u4G__cardAccommodationActive",
  "cardActive": "ExpandedItineraryScroller-module__3V3u4G__cardActive",
  "cardContent": "ExpandedItineraryScroller-module__3V3u4G__cardContent",
  "cardImage": "ExpandedItineraryScroller-module__3V3u4G__cardImage",
  "cardImagePlaceholder": "ExpandedItineraryScroller-module__3V3u4G__cardImagePlaceholder",
  "cardLeg": "ExpandedItineraryScroller-module__3V3u4G__cardLeg",
  "cardLegIcon": "ExpandedItineraryScroller-module__3V3u4G__cardLegIcon",
  "cardTagRow": "ExpandedItineraryScroller-module__3V3u4G__cardTagRow",
  "cardTitle": "ExpandedItineraryScroller-module__3V3u4G__cardTitle",
  "cardTitleAccommodation": "ExpandedItineraryScroller-module__3V3u4G__cardTitleAccommodation",
  "cardTitleRow": "ExpandedItineraryScroller-module__3V3u4G__cardTitleRow",
  "cardWithImage": "ExpandedItineraryScroller-module__3V3u4G__cardWithImage",
  "group": "ExpandedItineraryScroller-module__3V3u4G__group",
  "groupCards": "ExpandedItineraryScroller-module__3V3u4G__groupCards",
  "groupDate": "ExpandedItineraryScroller-module__3V3u4G__groupDate",
  "groupDay": "ExpandedItineraryScroller-module__3V3u4G__groupDay",
  "groupHeader": "ExpandedItineraryScroller-module__3V3u4G__groupHeader",
  "locationPill": "ExpandedItineraryScroller-module__3V3u4G__locationPill",
  "locationPillText": "ExpandedItineraryScroller-module__3V3u4G__locationPillText",
  "scroller": "ExpandedItineraryScroller-module__3V3u4G__scroller",
  "scrollerAccommodation": "ExpandedItineraryScroller-module__3V3u4G__scrollerAccommodation",
  "scrollerClip": "ExpandedItineraryScroller-module__3V3u4G__scrollerClip",
  "scrollerClipAccommodation": "ExpandedItineraryScroller-module__3V3u4G__scrollerClipAccommodation",
});
